import { Apps } from './Apps';
export default Apps;
